import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import FileBase64 from 'react-file-base64';
import SettingsPage from '../../views/SettingsPage/';

class Institution extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			insName : '',
			insAddr : '',
			insEmail : '',
			insPhone : '',
			insMobile : '',
			insFax : '',
			adminPerson : '',
			country : '',
			curType : 'INR',
			lang : 'English',
			insCodetic : '1',
			insCode : '',
			timeZone : 'Asia/Kolkata',
			files: [],
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			_redirect : false
		}
		/** bind function **/
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** This function will be call when page loading **/
	componentWillMount(){
		
		this.getcountry();
	}
	
	/** reset the form **/
	onClick(e){
		
		document.getElementById("insform").reset();
	}
	
	/** redirect to institution view **/
	onBack(e){
		
		this.setState({_redirect :true});
	}
	
	getFiles(files){
		this.setState({ files: files })
	}
	
	/** get country **/
	getcountry(){
	  
		GetData('home/getcountry').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** image reader **/
	/* getBase64(file) {
	   var reader = new FileReader();
	   reader.readAsDataURL(file);
	   reader.onload = function () {
		 console.log(reader.result);
	   };
	   reader.onerror = function (error) {
		 console.log('Error: ', error);
	   };
	} */
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.insName && this.state.insAddr && this.state.insEmail && this.state.insPhone && this.state.insMobile && this.state.insFax && this.state.adminPerson && this.state.country && this.state.curType && this.state.lang && this.state.insCodetic && this.state.insCode && this.state.timeZone && this.state.files){
			
			PostData('institution/add',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Institution Details Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("insform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
  render() {
	   
		if(this.state._redirect){
		  
			return (<Redirect to='/settings/institutionview'/>);
		}
		
	 var items = this.state.posts;
	  
    return (
		<div>
		  <SettingsPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
					  <form action="" method="post" role="form" id="insform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Institution Details</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>View</Button>
							</span>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Name</Label>
								  <Input type="text" name="insName" id="name" placeholder="Enter your name" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="country">Country</Label>
								  <select name="country" className="form-control" id="country" value={this.state.country} onChange={this.onChange}>
									<option value="">Select Country</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.name}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="addr">Institution Address</Label>
								  <Input type="textarea" name="insAddr" id="addr" rows="2" onChange={this.onChange} required
								 placeholder="Address..."/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="ctype">Currency Type</Label>
								  <Input type="text" name="curType"  id="ctype" required onChange={this.onChange} value="INR"/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="email">Email</Label>
								  <Input type="email" name="insEmail" id="email" placeholder="Enter your Email Id" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="lang">Language</Label>
								  <Input type="text" name="lang" id="lang" value="English" disabled onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="phone">Phone</Label>
								  <Input type="number" name="insPhone" id="phone" placeholder="Enter your Phone" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="code">Institution Code(This code will be used as the prefix for student admission number)</Label><br></br>
								  <input type="checkbox" name="insCodetic" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="mobile">Mobile</Label>
								  <Input type="number" name="insMobile" id="mobile" placeholder="Enter your Mobile" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="icode">Institution Code</Label>
								  <Input type="text" name="insCode" id="icode" placeholder="Enter Institution Code" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="fax">Institution Fax</Label>
								  <Input type="number" name="insFax" id="fax" placeholder="Enter Fax" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="timezone">Timezone</Label>
								  <Input type="text" name="timeZone" id="timezone" value="Asia/Kolkata" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="admin">Admin Contact Person</Label>
								  <Input type="text" name="adminPerson" id="admin" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="logo">Upload Logo</Label>
								  <FormGroup>
									<FileBase64 onDone={ this.getFiles.bind(this) } />
								  </FormGroup>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Institution;


// WEBPACK FOOTER //
// ./src/settings/Institution/Institution.js